import { Navigate } from '~/components/utils/Navigation';
import { useAuth } from '~/lib/auth';

export type IAnonymousGuardProps = {
  component: React.ReactElement;
};

export const AnonymousGuard: React.FC<IAnonymousGuardProps> = ({
  component,
}) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? <Navigate to="/" /> : component;
};
